package com.fireavert.events.shared.client

interface EventsNavigator {
    fun navToDestination(destination: Destination)
    sealed class Destination {
        data class DeviceDetails(val propertyId: Int, val deviceId: Int) : Destination()
        data class PropertyDetails(val propertyId: Int) : Destination()
    }
}